import httpApi from '../api/httpApi';
import useSWR from 'swr';
import { User } from '../../models/User';

const USER_URL = '/api/v1/user';

const useUserSWR = () => {
    const fetchUser = (query): Promise<User> => {
        return httpApi
            .get<{ user: User }>(query)
            .then((res) => {
                return res.getData().user;
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(USER_URL, fetchUser, {
        dedupingInterval: 600000, // 10min
        errorRetryCount: 3,
    });

    return {
        user: data ? data : null,
        isLoading: isLoading,
        isError: error,
        forceRefresh: mutate,
    };
};

export default useUserSWR;
